import { render } from "./BaoBiaoView.vue?vue&type=template&id=3035d350&scoped=true&ts=true"
import script from "./BaoBiaoView.vue?vue&type=script&lang=ts"
export * from "./BaoBiaoView.vue?vue&type=script&lang=ts"

import "./BaoBiaoView.vue?vue&type=style&index=0&id=3035d350&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3035d350"]])

export default __exports__